<template>
	<div class="container">
		<!-- Add your site or application content here -->
		<section class=" layout" id="layout">
			<div class="inputForm">
				<div class="form-date">
					<h4>日付を入力</h4>

					<input class="input-text date"
								 type="text"
								 :value="item.date"
								 @input="updateDate"
								 maxlength="16"/>
				</div>

				<div class="form-logo">
					<h4>新聞名を入力 (2〜4文字)</h4>

					<div class="layout-header-brand-logo">
						<div id="logoHeader">
							<div class="left">新聞</div>

							<div class="right">
								<span
										field-name="logo"
										ref="logo"
										contenteditable
										@input="updateLogo"
										:class="logoClass"
										@keyup="submitTextHeaderMobile"
										class="input-contenteditable logoText"
										v-html="tmpLogo"></span>

								<span class="placeholder" v-if="isShowPlaceholder">
									２<span class="sign">〜 </span>4文字
								</span>
							</div>
						</div>
					</div>
				</div>

				<div class="form-issuer">
					<h4>発行者を入力</h4>

					<InputText
							:title="item.issuer"
							:placeholder="`発行者を入力`"
							:max-length="10"
							:field-name="'issuer'"
							:text-horizontal="true"
							:is-mobile="true"
					/>
				</div>

				<div class="form-headline" :class="{'form-headline-blackBG': this.item.background}">
					<h4> 見出しを入力（7〜10文字）</h4>

					<InputText
							:title="item.headline"
							:placeholder="`主見出しを入力（7〜10文字）`"
							:max-length="10"
							:field-name="'headline'"
							:text-horizontal="true"
							:is-mobile="true"
					/>
					<div id="changeBackground" @click="changeBackground">
						背景を変更
					</div>

				</div>

				<div class="form-sleeve-title">
					<h4> そで見出し①を入力（7〜8文字）</h4>

					<InputText
							:title="item.sleeve_title"
							:placeholder="`そで見出し①を入力（７〜８文字）`"
							:max-length="8"
							:field-name="'sleeve_title'"
							:text-horizontal="true"
							:is-mobile="true"
					/>
				</div>


				<div class="form-title">
					<h4>そで見出し②を入力（7〜10）文字</h4>

					<InputText
							:title="item.article_title"
							:placeholder="`見出しを入力（7〜10文字）`"
							:max-length="10"
							:field-name="'article_title'"
							:text-horizontal="true"
							:is-mobile="true"
					/>
				</div>

				<div class="summary">
					<h4 v-if="item.isLarge">リード文を入力（大・最大102文字）</h4>
					<h4 v-else>リード文を入力（小・最大176文字）</h4>

					<InputText
							:title="item.lead_sentence"
							:placeholder="`リード文を入力（最大 <span class='num'>１７６</span>文字）`"
							:max-length="176"
							:field-name="'lead_sentence'"
							:text-horizontal="false"
							:is-mobile="true"
							:is-summary="true"
					/>
					<div id="changeBackground" @click="changeFontSize">
						文字サイズ変更
					</div>
				</div>
				<div class="imgLoader">
					<h4> 写真をアップロード</h4>

					<form class="layout-upload-form">
						<!--upload image-->
						<input
								id="file-upload"
								type="file"
								name="file-upload"
								ref="input"
								accept="image/*"
								@change="setImage"
						/>

						<label for="file-upload" class="custom-file-upload">写真を選ぶ</label>
						<vue-cropper
								v-show="item.image_url"
								ref="cropper"
								class="crop-wrap"
								:src="item.image_url"
								:autoCropArea="1"
								:viewMode="3"
								:modal="false"
								:cropBoxMovable="true"
								:cropBoxResizable="false"
								:guides="false"
								:restore="false"
								:hightlight="false"
								:background="false"
								:zoomable="true"
								:toggleDragModeOnDblclick="false"
						/>

						<!--list button event handler image -->
						<div :class="{ hidden: selected }" id="btn-editor">
							<div class="btn-editor-img">
								<!--Zoom delete image-->
								<div class="btn" id="reset" @click="resetImage">
									<span>リセット</span>

									<i class="fa fa-repeat">
										<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-repeat"><polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path></svg>
									</i>
								</div>

								<!--Upload new image-->
								<label class="btn" for="file-upload" id="upload">
									<span>アップロード</span>

									<i class="fa fa-upload">
										<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
									</i>
								</label>
							</div>
						</div>
					</form>

				</div>

				<div class="">
					<h4> 絵解きを入力（40文字以内）</h4>

					<InputText
							:title="item.image_caption"
							:placeholder="`絵解きを入力（４０文字以内）`"
							:max-length="40"
							:field-name="'image_caption'"
							:text-horizontal="true"
							:is-mobile="true"
					/>
				</div>

				<div class="layout-content">
					<h4 v-if="item.isLarge">記事を入力（大・最大390文字）</h4>
					<h4 v-else>記事を入力（小・最大624文字）</h4>
					<InputText
							:title="item.content"
							:placeholder="`記事を入力（最大 <span class='num'>624</span>文字）`"
							:max-length="624"
							:field-name="'content'"
							id="main-content"
							:is-mobile="true"
							:is-content="true"
							:is-html="true"
					/>
					<div id="changeBackground" @click="changeFontSize">
						文字サイズ変更
					</div>
				</div>
			</div>
		</section>

	</div>

</template>

<script>
	// Components
	import InputText from '../shared/InputText'

	// supporter
	import VueCropper from 'vue-cropperjs'
	import 'cropperjs/dist/cropper.css'
	import _ from 'lodash'

	// mixins
	import NewspaperMixin from '../../mixins/newspaper.mixin'
	import KeyHandlingMixin from '../../mixins/keyHandling.mixin'
	import FormHeaderMixin from '../../mixins/formHeader.mixin'
	import ImageCropperMixin from '../../mixins/imageCropper.mixin'

	// Models
	import NewspaperModel from '../../models/newspaper.model'

	export default {
		name: 'FormMobile',

		mixins: [
			NewspaperMixin('layout-scale'),
			KeyHandlingMixin,
			FormHeaderMixin,
			ImageCropperMixin
		],

		components: {
			VueCropper,
			InputText
		},

		data () {
			return {
				selected: true,
				mainTitleLength: '',
				mainContentFocus: true
			}
		},
		mounted() {
      if(this.item.image_url) {
        this.selected = false;
      }
    },

		computed: {
			item () {
				return NewspaperModel.query().find(1)
			}
		},

		methods: {
			/**
			 * Update for HeaderLine
			 */
			updateHeadline (e) {
				this.item.headline = e.target.value

				this.item.$save()
			},

			selectHTML () {
				try {
					if (window.ActiveXObject) {
						let RANGE = document.selection.createRange()
						return RANGE.htmlText
					}

					let SPAN = document.createElement('span'),
							w = getSelection().getRangeAt(0)

					SPAN.classList.add('num')

					w.surroundContents(SPAN)
					return SPAN.innerHTML
				} catch (e) {
					if (window.ActiveXObject) {
						return document.selection.createRange()
					} else {
						return getSelection()
					}
				}
			},

			rotateNumber () {
				this.selectHTML()
				let el = document.getElementById('main-content').childNodes[0]
				let range = document.createRange()
				let sel = window.getSelection()

				range.setStart(el, 0)
				range.collapse(true)

				sel.removeAllRanges()
				sel.addRange(range)
				el.focus()
			},

      changeBackground () {
        this.item.background = !this.item.background

        this.item.$save()
      },

			changeFontSize () {
				this.item.isLarge = !this.item.isLarge

				this.item.$save()
      }
		}
	}
</script>